// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"921a5342","513":"6019a926","703":"e82de775","787":"884e199e"}[chunkId] + ".chunk.js";
};